import { WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION } from "../../schema/websiteBuilderCurrentSchemaVersion";
import { TWebsiteBuilderNode } from "../websiteBuilderNode";
import {
  IWebsiteBuilderSectionBase,
  IWebsiteBuilderSectionDataBase,
  websiteBuilderGenerateDefaultSectionBackground,
} from "./websiteBuilderSection";

export const WEBSITE_BUILDER_FOOTER_ID = "footer";

export interface IWebsiteBuilderFooterData extends IWebsiteBuilderSectionDataBase {
  type: typeof WEBSITE_BUILDER_FOOTER_ID;
}

export interface IWebsiteBuilderFooter extends IWebsiteBuilderSectionBase {
  id: typeof WEBSITE_BUILDER_FOOTER_ID;
  schemaVersion: number;
  section: IWebsiteBuilderFooterData;
}

export function isWebsiteBuilderFooter(node: TWebsiteBuilderNode): node is IWebsiteBuilderFooter {
  return node.id === WEBSITE_BUILDER_FOOTER_ID && node?.type === "section" && node.section?.type === "footer";
}

export function websiteBuilderGenerateDefaultFooter(): IWebsiteBuilderFooter {
  return {
    id: "footer",
    type: "section",
    schemaVersion: WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION,
    section: {
      type: "footer",
      layout: {
        desktop: {
          height: 100,
        },
        tablet: {
          height: 100,
        },
        mobile: {
          height: 100,
        },
      },
      background: websiteBuilderGenerateDefaultSectionBackground(),
    },
    children: [],
  };
}
